
export function request(eventId, tagId) {
    return {
        type: 'GET_EVENT_INFO_BY_CONTINGENCY_ID_REQUEST',
        eventId,
        tagId
    };
}

export function error(errors) {
    return {
        type: 'GET_EVENT_INFO_BY_CONTINGENCY_ID_ERROR',
        errors
    };
}

export function finish(items) {
    return {
        type: 'GET_EVENT_INFO_BY_CONTINGENCY_ID_FINISH',
        items
    };
}
